import React, { createContext, useContext, useEffect, useState } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { themeConfig } from './themeConfig';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

const prefersDark = () => {
  try {
    const saved = localStorage.getItem('theme');
    return saved === 'dark' || (!saved && window.matchMedia('(prefers-color-scheme: dark)').matches);
  } catch (error) {
    return false;
  }
};

const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(prefersDark);

  useEffect(() => {
    try {
      localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    } catch (error) {
      console.warn('Could not save theme preference');
    }
  }, [isDarkMode]);

  const currentTheme = isDarkMode ? themeConfig.dark : themeConfig.light;
  const value = {
    isDarkMode,
    toggleTheme: () => setIsDarkMode((prev) => !prev),
    theme: currentTheme,
    colors: currentTheme.palette,
  };

  return (
    <ThemeContext.Provider value={value}>
      <MuiThemeProvider theme={currentTheme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export { ThemeProvider };
export default ThemeProvider;
